// structures.ts — Endpoints structures (éléments d'organisation, graphe).
import { req } from './_internals.js';

export const structuresApi = {
  getStructures: () => req('GET', '/structures'),
  // Le référentiel `structures` est volontairement FERMÉ en lecture
  // (`structures.read`, décision juin 2026). Les pages qui ne s'en servent que
  // comme filtre OPTIONNEL passent par ce helper : sans le droit, on ne tape
  // pas le réseau (évite un 403 inoffensif mais bruyant en console) et on
  // renvoie une liste vide. La page d'admin des structures, elle, est gardée
  // par la route (`structures.read`) et appelle `getStructures()` directement.
  getStructuresIfAllowed: () =>
    typeof window !== 'undefined' && window.hasPermission?.('structures.read')
      ? req('GET', '/structures')
      : Promise.resolve([]),
  // Combo de filtre « organisation » de #actions : référentiel MINIMAL
  // (id/code/label/is_active/parent_ids) OUVERT à tout utilisateur, comme les
  // projets — indépendant de `structures.read`. `parent_ids` alimente le rollup
  // d'escalade côté front. Mirroir front de `GET /structures/options`.
  getStructuresForFilter: () => req('GET', '/structures/options'),
  createStructure: (d: unknown) => req('POST', '/structures', d),
  updateStructure: (id: number | string, d: unknown) => req('PUT', '/structures/' + id, d),
  deleteStructure: (id: number | string) => req('DELETE', '/structures/' + id),
};
